import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { untilDestroyed } from 'ngx-take-until-destroy';
import {
  CheckboxConfig,
  FormFieldConfig,
  formTemplateGenericSort,
  SpecialValueKey
} from './../../../form-template-model';
import { FormTemplateGeneratorService } from './../../form-template-generator.service';

@Component({
  selector: 'csi-form-template-checkbox-field-generator',
  templateUrl: './form-template-checkbox-field-generator.component.html',
  styleUrls: ['./form-template-checkbox-field-generator.component.css']
})
export class FormTemplateCheckboxFieldGeneratorComponent implements OnInit, OnDestroy {
  @Input() config: FormFieldConfig & { typeConfig: CheckboxConfig };
  @Input() checkboxFormGroup: FormGroup;
  @Input() formTemplateFieldKey: string;
  @Input() readOnly: boolean;
  @Input() formatForPDF: boolean;
  @Input() supportingFields: { [key: string]: FormFieldConfig };

  public valuesConfigSpecialOptions = {};
  public valuesConfigNonSpecialOptions = {};
  public hasSpecialOptions = false;

  sortValues = formTemplateGenericSort;
  constructor(public formTemplateGeneratorService: FormTemplateGeneratorService) {}

  ngOnInit() {
    if (this.config.typeConfig && this.config.typeConfig.valuesConfig) {
      Object.entries(this.config.typeConfig.valuesConfig).map(([key, value]) => {
        if (value['isSpecialOption']) {
          this.valuesConfigSpecialOptions[key] = value;
          this.handleSpecialOption(key);
        } else {
          this.valuesConfigNonSpecialOptions[key] = value;
        }
      });
    }
    if (Object.keys(this.valuesConfigSpecialOptions).length > 0) {
      this.hasSpecialOptions = true;
    }
  }

  handleSpecialOption(key: string) {
    switch (key) {
      case SpecialValueKey.NONE: {
        this.checkboxFormGroup.controls[key].valueChanges
          .pipe(untilDestroyed(this))
          .subscribe(val => {
            // null is emitted when control is enabled/disabled
            if (val !== null && !this.checkboxFormGroup.controls[key].disabled) {
              this.uncheckNonSpecialOptions();
              this.setNonSpecialOptionControlsState(val);
            }
          });
        break;
      }
    }
  }

  setNonSpecialOptionControlsState(disabled: boolean) {
    // Avoid toggling disable at the same time as a trigger
    setTimeout(() => {
      for (const key of Object.keys(this.valuesConfigNonSpecialOptions)) {
        const control = this.checkboxFormGroup.controls[key];
        if (control) {
          control[disabled ? 'disable' : 'enable']();
        }
      }
    });
  }

  uncheckNonSpecialOptions() {
    for (const key of Object.keys(this.valuesConfigNonSpecialOptions)) {
      const control = this.checkboxFormGroup.controls[key];
      if (control) {
        control.patchValue(false);
      }
    }
  }

  ngOnDestroy() {}
}
